import React from "react";
import EngineDrillDownPage from "../../../../components/pages/_new/super/engines/EngineDrillDownPage";

const BmDetailPage = () => <EngineDrillDownPage engineType="BM_ENGINE" />;

export default BmDetailPage;
